import React from 'react';
import styled from '@emotion/styled';
import { color } from '@/theme';

import { BoldText, RegularText } from '@/components/text';

const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

const NumberIconContainer = styled.div(({ theme, active }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 2.4rem',
  minWidth: '30rem',

  '&:after': {
    position: 'absolute',
    content: '""',
    width: 'calc(100% - 16rem)',
    height: '0.1rem',
    background: active ? theme.color.base_purple : theme.color.base_gray,
    left: '50%',
    transform: 'translateX(-50%)',
    top: '2.5rem',
    zIndex: -1,
  },
}));

const NumberItem = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2rem',
  minWidth: '9rem',
  maxWidth: '9rem',
}));

const NumberIcon = styled.div(({ theme, active }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '5rem',
  height: '5rem',
  background: active ? theme.color.base_purple : theme.color.base_gray,
  color: theme.color.base_white,
  borderRadius: '50%',
}));
const NumberText = styled.div(({ theme, active }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: active ? theme.color.base_purple : theme.color.base_white,

  whiteSpace: 'preserve',
  textAlign: 'center',
}));

const InquirySteps = ({ step }) => {
  return (
    <Container>
      <NumberIconContainer active={step === 1}>
        <NumberItem>
          <NumberIcon active={step >= 1}>
            <BoldText color={color.base_white}>1</BoldText>
          </NumberIcon>

          <NumberText>
            <RegularText
              id="lang-inquiry-step-one"
              fontSize="1.6rem"
              color={step >= 1 ? color.base_purple : color.base_gray}
            />
          </NumberText>
        </NumberItem>

        <NumberItem>
          <NumberIcon active={step >= 2}>
            <BoldText color={color.base_white}>2</BoldText>
          </NumberIcon>

          <NumberText>
            <RegularText
              id="lang-inquiry-step-two"
              fontSize="1.6rem"
              color={step >= 2 ? color.base_purple : color.base_gray}
            />
          </NumberText>
        </NumberItem>
      </NumberIconContainer>
    </Container>
  );
};

export default InquirySteps;
